import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/Fraport_Logo_Slovenija.svg'


const _hoisted_1 = { class: "h-screen bg-background flex flex-col" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "relative z-10 h-full flex items-center justify-center" }
const _hoisted_4 = { class: "max-w-7xl w-full px-4 sm:px-6 lg:px-8" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "flex items-center max-w-6xl w-full" }
const _hoisted_7 = { class: "w-1/2 flex justify-center" }
const _hoisted_8 = { class: "w-full max-w-md" }
const _hoisted_9 = {
  key: 1,
  class: "flex h-full"
}
const _hoisted_10 = { class: "flex-1 overflow-auto p-6 transition-all duration-300 bg-gray-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_RegisterForm = _resolveComponent("RegisterForm")!
  const _component_SideNav = _resolveComponent("SideNav")!
  const _component_Dashboard = _resolveComponent("Dashboard")!
  const _component_EmailGenerator = _resolveComponent("EmailGenerator")!
  const _component_UserSettings = _resolveComponent("UserSettings")!
  const _component_SupabaseTest = _resolveComponent("SupabaseTest")!
  const _component_StorageTest = _resolveComponent("StorageTest")!
  const _component_ForecastingPCO = _resolveComponent("ForecastingPCO")!
  const _component_Administration = _resolveComponent("Administration")!
  const _component_ForecastingPlanners = _resolveComponent("ForecastingPlanners")!
  const _component_TemplateStorageExample = _resolveComponent("TemplateStorageExample")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      (!_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "relative h-full bg-cover bg-center",
            style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/airport-background.jpg')})` })
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 backdrop-blur-lg bg-black/40" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"w-1/2 pr-8\"><div class=\"mb-6\"><img src=\"" + _imports_0 + "\" alt=\"Fraport Slovenija Logo\" class=\"h-24 w-auto invert brightness-0 filter\"></div><h1 class=\"text-4xl font-bold text-white mb-4 text-shadow\">Welcome to Fraport Insights - Your Intelligent Airport Management Solution</h1><p class=\"text-xl text-white text-shadow\">Streamline airport operations with advanced forecasting and AI-powered workflow optimization.</p></div>", 1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.showLoginForm)
                          ? (_openBlock(), _createBlock(_component_LoginForm, {
                              key: 0,
                              onLoginSuccess: _ctx.handleLoginSuccess,
                              onSwitchToRegister: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showRegisterForm = true; _ctx.showLoginForm = false})
                            }, null, 8, ["onLoginSuccess"]))
                          : (_openBlock(), _createBlock(_component_RegisterForm, {
                              key: 1,
                              onRegisterSuccess: _ctx.handleRegisterSuccess,
                              onSwitchToLogin: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showRegisterForm = false; _ctx.showLoginForm = true})
                            }, null, 8, ["onRegisterSuccess"]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], 4))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_SideNav, {
              activeItem: _ctx.activeNavItem,
              userData: _ctx.userData,
              onNavigate: _ctx.handleNavigation,
              onLogout: _ctx.logout,
              onToggleCollapse: _ctx.handleSideNavCollapse
            }, null, 8, ["activeItem", "userData", "onNavigate", "onLogout", "onToggleCollapse"]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.activeNavItem === 'dashboard')
                ? (_openBlock(), _createBlock(_component_Dashboard, { key: 0 }))
                : (_ctx.activeNavItem === 'email-generator')
                  ? (_openBlock(), _createBlock(_component_EmailGenerator, { key: 1 }))
                  : (_ctx.activeNavItem === 'user-settings')
                    ? (_openBlock(), _createBlock(_component_UserSettings, {
                        key: 2,
                        userData: _ctx.userData,
                        onUpdateUserData: _ctx.updateUserData
                      }, null, 8, ["userData", "onUpdateUserData"]))
                    : (_ctx.activeNavItem === 'supabase-test')
                      ? (_openBlock(), _createBlock(_component_SupabaseTest, { key: 3 }))
                      : (_ctx.activeNavItem === 'storage-test')
                        ? (_openBlock(), _createBlock(_component_StorageTest, { key: 4 }))
                        : (_ctx.activeNavItem === 'forecasting-pco')
                          ? (_openBlock(), _createBlock(_component_ForecastingPCO, { key: 5 }))
                          : (_ctx.activeNavItem === 'administration')
                            ? (_openBlock(), _createBlock(_component_Administration, {
                                key: 6,
                                initialView: _ctx.administrationSubView
                              }, null, 8, ["initialView"]))
                            : (_ctx.activeNavItem === 'forecasting-planners')
                              ? (_openBlock(), _createBlock(_component_ForecastingPlanners, { key: 7 }))
                              : (_ctx.activeNavItem === 'template-storage')
                                ? (_openBlock(), _createBlock(_component_TemplateStorageExample, { key: 8 }))
                                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}